import React from "react";

function CommunityGuidelines() {
  return (
    <div className="p-8 flex flex-col max-w-[1060px] text-[16px] text-[#202126] m-auto">
      <div className=" text-[24px] text-black ">
        Google Community Guidelines and Anti-Harassment Policy for In-Person and
        Virtual Events
      </div>
      <br />
      Google is dedicated to providing a harassment-free and inclusive event
      experience for everyone regardless of gender identity and expression,
      sexual orientation, disabilities, neurodiversity, physical appearance,
      body size, ethnicity, nationality, race, age, religion, or other protected
      category. We do not tolerate harassment of event participants in any form.
      Google takes violations of our policy seriously and will respond
      appropriately.
      <br /> <br />
      All participants of Google events, including in-person and online
      attendees, event staff, speakers, and Googlers, must abide by the
      following policy:
      <br />
      <br />
      <div>
        <b>Be respectful to each other.</b>Treat everyone with respect.
        Participate while acknowledging that everyone deserves to be here — and
        each of us has the right to enjoy our experience without fear of
        harassment, discrimination, or condescension, whether blatant or via
        micro-aggressions. All forms of communication should not demean others.
        Consider what you are saying and how it would feel if it were said to
        you or about you.
      </div>
      <br />
      <div>
        <b>Speak up if you see or hear something.</b> Harassment is not
        tolerated, and you are empowered to politely engage when you or others
        are disrespected. The person making you feel uncomfortable may not be
        aware of what they are doing, and politely bringing their behavior to
        their attention is encouraged. <br />
        <br />
      </div>
      <div>
        We have a <b>ZERO TOLERANCE POLICY </b>for in-person or online
        harassment of any kind, including but not limited to:
      </div>
      <br />
      <ul
        style={{ listStyleType: "disc" }}
        className="grid md:grid-cols-3 pl-10"
      >
        <div className=" flex flex-col gap-2 max-w-[260px]">
          <li>Stalking/following</li>
          <li>Deliberate intimidation</li>
          <li>Harassing photography or recording</li>
          <li>Sustained disruption of talks or other events</li>
        </div>
        <div className=" flex flex-col gap-2 max-w-[260px]">
          <li>Offensive verbal language</li>
          <li>
            Verbal language that reinforces social structures of domination
          </li>
          <li>Sexual imagery and language in public spaces</li>
        </div>
        <div className=" flex flex-col gap-2 max-w-[260px]">
          <li>Inappropriate physical contact</li>
          <li>Unwelcome sexual or physical attention</li>
          <li>Physical or cyber threats</li>
        </div>
      </ul>
      <br />
      <b> In relation to, but not limited to: </b>
      <br />
      <ul
        style={{ listStyleType: "disc" }}
        className=" grid sm:grid-cols-3 pl-10"
      >
        <div className=" flex flex-col gap-2 max-w-[260px]">
          <li>Neurodiversity</li>
          <li>Race</li>
          <li>Color</li>
          <li>National origin</li>
          <li>Gender identity</li>
        </div>
        <div className=" flex flex-col gap-2 max-w-[260px]">
          <li>Gender expression</li>
          <li>Sexual orientation</li>
          <li>Age</li>
          <li>Body size</li>
          <li>Disabilities</li>
        </div>
        <div className=" flex flex-col gap-2 max-w-[260px]">
          <li>Appearance</li>
          <li>Religion</li>
          <li>Pregnancy</li>
          <li>Military status</li>
          <li>Social demograpic</li>
        </div>
      </ul>
      <br />
      Participants asked to stop any harassing behavior are expected to comply
      immediately. Our zero tolerance policy means that we will look into and
      review every allegation of violation of our Event Community Guidelines and
      Anti-Harassment Policy and respond appropriately. To report any behavior
      that makes you or others feel uncomfortable, visit your event's website to
      file a report to your event's organizers.
      <br />
      <br />
      This policy extends to talks, forums, workshops, codelabs, social media,
      all attendees, partners, sponsors, volunteers, staff, etc. You catch our
      drift. Google reserves the right to refuse admittance to, or remove any
      person from, any Google hosted event (including future Google events) at
      any time in its sole discretion. This includes, but is not limited to,
      attendees behaving in a disorderly manner or failing to comply with this
      policy, and the terms and conditions herein. If a participant engages in
      harassing or uncomfortable behavior, the conference organizers may take
      any action they deem appropriate, including warning or expelling the
      offender from the conference with no refund or blocking the offender’s
      account from participating online.
    </div>
  );
}

export default CommunityGuidelines;
